import { create } from "zustand";

export const useCommunicationStore = create((set, get) => ({
  // State
  communications: [],
  loading: false,
  error: null,
  selectedCommunication: null,
  searchQuery: "",
  filters: {},

  // Table features
  columnFilters: {},
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
  },

  // Modal / UI states
  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  communicationToDelete: null,
  isDetailDialogOpen: false,
  communicationToView: null,

  // Basic Setters
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  setCommunications: (communications) => set({ communications }),
  setSelectedCommunication: (communication) => set({ selectedCommunication: communication }),

  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setFilters: (filters) => set({ filters }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setPaginationData: (data) => set((state) => ({
    paginationData: {
      ...state.paginationData,
      ...data,
      currentPage: data.page || data.currentPage || state.paginationData.currentPage,
      itemsPerPage: data.pageSize || data.itemsPerPage || state.paginationData.itemsPerPage,
      totalItems: data.total || data.totalItems || state.paginationData.totalItems,
      totalPages: data.totalPages || state.paginationData.totalPages,
    }
  })),

  // UI Flow Actions
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedCommunication: null,
    error: null
  }),

  openEditForm: (communication) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedCommunication: communication,
    error: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    selectedCommunication: null,
    error: null
  }),

  openDeleteDialog: (communication) => set({
    isDeleteDialogOpen: true,
    communicationToDelete: communication,
    error: null
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    communicationToDelete: null,
    error: null
  }),

  openDetailDialog: (communication) => set({
    isDetailDialogOpen: true,
    communicationToView: communication,
    error: null
  }),

  closeDetailDialog: () => set({
    isDetailDialogOpen: false,
    communicationToView: null,
    error: null
  }),
}));
